<div class="top-navigation-wrapper icons-center">
  <div id="buSelection" class="bu-section" *ngIf="(activeModule === moduleType.ProjectValuation || activeModule === moduleType.Comparables) && userBusinessUnits && userCurrentBusinessUnit && isAdminOrMoreThanOneBu">
    <div class="labelContainer">
      <span class="dialogLabel uppercase">{{ 'common.activeBusinessUnit' | translate }}</span>
    </div>
    <div class="fieldContainer">
      <kendo-dropdownlist id="buSelector"
                          [data]="userBusinessUnits"
                          [(ngModel)]="userCurrentBusinessUnit"
                          (ngModelChange)="activeBusinessUnitChanged()"
                          textField="description"
                          [valuePrimitive]="true"
                          valueField="oid">
        <ng-template kendoDropDownListItemTemplate let-dataItem>
          <span *ngIf="!dataItem.directAssignment" style="font-style: italic;">{{ dataItem.description }}</span>
          <span *ngIf="dataItem.directAssignment">{{ dataItem.description }}</span>
        </ng-template>
      </kendo-dropdownlist>
    </div>   
  </div>
  <div id="projectValuation" *ngIf="activeModule === moduleType.ProjectValuation">
    <project-navigation [searchTabVisible]="searchTabVisible" *ngIf="selectedTab === projectValuationsActiveTab.Projects"></project-navigation>
    <valuation-portofolio-navigation [searchTabVisible]="searchTabVisible" *ngIf="selectedTab === projectValuationsActiveTab.ValPortofolios"></valuation-portofolio-navigation>
    <dashboard-navigation [searchTabVisible]="searchTabVisible" *ngIf="selectedTab === projectValuationsActiveTab.Dashboards"></dashboard-navigation>
    <properties-navigation *ngIf="selectedTab === projectValuationsActiveTab.Properties"></properties-navigation>
    <tenant-navigation *ngIf="selectedTab === projectValuationsActiveTab.Tenant"></tenant-navigation>
  </div>
  <div *ngIf="activeModule === moduleType.Comparables" id="comparablesActions">
    <comparables-actions-navigation [selectedTab]="selectedTab" [searchTabVisible]="searchTabVisible"></comparables-actions-navigation>
  </div>
  <div id="admin" *ngIf="activeModule === moduleType.AppSettings">
    <roles-management-navigation *ngIf="selectedTab === adminActiveTab.ApprovalStatusPageSetup"></roles-management-navigation>
    <calculation-model-navigation *ngIf="isCalculationModelArea"></calculation-model-navigation>
    <raci-template-navigation *ngIf="isRaciTemplateArea"></raci-template-navigation>
    <localization-navigation *ngIf="isLocalizationArea"></localization-navigation>
    <div class="navigation-items action-items" [ngClass]="selectedTab === adminActiveTab.CurrenciesManagement ? 'navigation-border-right' : ''">
      <div *ngIf="selectedTab === adminActiveTab.BusinessUnits" class="action-icon" (click)="addNewBU()">
        <svg-icon src='./assets/icons/add_new.svg'
                  class="menu-action-icon svg-icon-gray"></svg-icon>
        <div class="icon-label">{{'actions.add' | translate | uppercase}}</div>
      </div>
      <div *ngIf="selectedTab === adminActiveTab.CurrenciesManagement" class="action-icon" (click)="triggerAction('settingsCurrenciesManagementAddNewRow')">
        <svg-icon src='./assets/icons/add_new.svg'
                  title="ADD NEW RECORD"
                  class="menu-action-icon svg-icon-gray"></svg-icon>
        <div class="icon-label">{{'actions.add' | translate | uppercase}}</div>
      </div>
      <div *ngIf="selectedTab === adminActiveTab.Users" class="action-icon"
           (click)="triggerAction('settingsUserManagementaddNewRow')">
        <svg-icon src='./assets/icons/add_new.svg' title="ADD NEW RECORD" class="menu-action-icon svg-icon-gray"></svg-icon>
        <div class="icon-label">{{'actions.add' | translate | uppercase}}</div>
      </div>
      <div *ngIf="selectedTab === adminActiveTab.Users" class="action-icon"
           (click)="triggerAction('settingsUserManagementExportLogins')">
        <svg-icon src='./assets/icons/download_export.svg' title="EXPORT LOGINS" class="menu-action-icon svg-icon-gray"></svg-icon>
        <div class="icon-label">{{'actions.exportLogins' | translate | uppercase}}</div>
      </div>
    </div>
    <div *ngIf="selectedTab === adminActiveTab.CurrenciesManagement" class="navigation-items action-items">
      <div class="action-icon" (click)="triggerAction('settingsCurrenciesManagementSave')">
        <svg-icon src='./assets/icons/save.svg' title="SAVE"
                  class="menu-action-icon svg-icon-gray"></svg-icon>
        <div class="icon-label">{{'actions.save' | translate | uppercase}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="activeModule === moduleType.Dataverse" id="dataverseActions">
    <dataverse-actions-navigation-v2></dataverse-actions-navigation-v2>
  </div>
  <div class="navbar" [ngClass]="activeModule === moduleType.ProjectValuation || activeModule === moduleType.ProjectMain ? 'counter-modules-wrapper' : ''">
    <div class="right-section">
      <div class="menuItem topnav">
        <button #anchor (click)="showPopup()" class="navigation-menu-btn round-button" (mouseenter)="showPopup()">
          <svg-icon #svgIcon [src]="activeSvg" height='28' width='28' align='center' class="selected-icon"></svg-icon>
        </button>
      </div>
    </div>
    <div class="right-section">
      <div class="open-tasks topnav action-icon" [routerLink]="['/user-dashboard/overview']">
        <svg-icon #svgIcon src='./assets/icons/mail-outline.svg' height='28' width='28' align='center' class="menu-notification-icon"></svg-icon>
        <div class="basket-items" *ngIf="tasksCount$ | async as tasksCount">
          {{tasksCount}}
        </div>
        <p class="linkLabel">{{'notification.openTasks' | translate | uppercase}}</p>
      </div>
    </div>
    <div class="left-section">
      <div style="white-space:nowrap; display:inline-flex;">
        <project-valuation-counter-card *ngIf="activeModule === moduleType.ProjectValuation || activeModule === moduleType.ProjectMain" [linkCounter]="linkCounter"></project-valuation-counter-card>
      </div>
    </div>
  </div>
  <div class="left-section">
    <div>
      <raci-counter-card *ngIf="activeModule === moduleType.Raci" [linkCounter]="linkCounter"></raci-counter-card>
    </div>
  </div>
  <div *ngIf="activeModule === moduleType.Raci">
    <raci-navigation></raci-navigation>
  </div>
  <div *ngIf="activeModule === moduleType.UserDashboard">
    <user-dashboard-navigation></user-dashboard-navigation>
  </div>
  <kendo-popup [anchor]="anchor"
               *ngIf="show"
               class="inner-wrapper">
    <div class="content" (mouseenter)="showPopup()" (mouseleave)="hidePopup()">
      <div>
        <div class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.UserDashboard}" [routerLink]="['/user-dashboard/overview']" title="USER DASHBOARD">
          <a>
            <div class="menu-icon">
              <svg-icon src='./assets/icons/users.svg' alt="USER DASHBOARD" height='28' width='28' align='center'></svg-icon> <br />
            </div>
            <span>USER DASHBOARD</span>
          </a>
        </div>
        <div *ngIf="isAdmin" class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.Comparables}" [routerLink]="['/cmp']" title="PROPERTY POOL">
          <a>
            <div class="menu-icon">
              <svg-icon src='./assets/icons/Properties_icon.svg' alt="COMPARABLES" height='28' width='28' align='center'></svg-icon> <br />
            </div>
            <span>PROPERTY POOL</span>
          </a>
        </div>
      </div>

      <div>
        <div class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.ProjectValuation}" [routerLink]="['/pd']" title="PROJECT ORGANISATION" (click)="goToProjectOrganisation()">
          <a>
            <div class="menu-icon">
              <svg-icon src='./assets/icons/Val_Portfolios_icon.svg' alt="PROJECT ORGANISATION" height='28' width='28' align='center'></svg-icon> <br />
            </div>
            <span>PROJECT ORGANISATION</span>
          </a>
        </div>
        <div *ngIf="isAdmin" class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.ReportDesigner}" [routerLink]="['/rd']" title="REPORT DESIGNER">
          <a>
            <div class="menu-icon">
              <svg-icon src='./assets/icons/ReportDesigner.svg' alt="REPORT DESIGNER" height='28' width='28' align='center'></svg-icon> <br />
            </div>
            <span>REPORT DESIGNER</span>
          </a>
        </div>
        <div class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.Raci, 'disabled-element': hideRaci === true}" [routerLink]="['/raci']" title="RACI">
        </div>
      </div>

      <div>
        <div *ngIf="isAdmin" class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.AppSettings}" [routerLink]="['/set']" title="ADMIN">
          <a>
            <div class="menu-icon">
              <svg-icon src='./assets/icons/AdminConsole.svg' alt="ADMIN" height='28' width='28' align='center'></svg-icon> <br />
            </div>
            <span>ADMIN</span>
          </a>
        </div>
        <div *ngIf="isAdmin || isBusinessAnalyst" class="menuItem topnav" [ngClass]="{'active': activeModule === moduleType.Dataverse}" [routerLink]="['/dataverse']" title="DATAVERSE">
          <a>
            <div class="menu-icon">
              <svg-icon src='./assets/icons/cog.svg' alt="DATAVERSE" height='28' width='28' align='center'></svg-icon> <br />
            </div>
            <span>DATAVERSE</span>
          </a>
        </div>
      </div>
    </div>
  </kendo-popup>
</div>
